import { render, staticRenderFns } from "./ImpresionBoletos.vue?vue&type=template&id=68fb767c&scoped=true&"
import script from "./ImpresionBoletos.vue?vue&type=script&lang=js&"
export * from "./ImpresionBoletos.vue?vue&type=script&lang=js&"
import style0 from "./ImpresionBoletos.vue?vue&type=style&index=0&id=68fb767c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fb767c",
  null
  
)

export default component.exports